import { AntTag } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { refetchFunc } from 'modules/domain/common/hooks'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'
import { ARouterLink } from 'views/components/Analytics'
import { EditSampleModal } from 'views/pages/Bid/BidDetail/Bid/Samples/EditSampleModal'
import SamplesRoutes from 'views/pages/Samples/routes'
import { SamplesCommonTable } from './SamplesCommonTable'
import { SampleWithRequests } from 'views/pages/Samples/types'
import { SamplePartsForAccordion } from './SamplePartsForAccordion'

type Props = {
  actualSample: SampleWithRequests
  sampleRefetch: refetchFunc
}

export const SampleForAccordion: FC<Props> = ({ actualSample, sampleRefetch }) => {
  const { t } = useTranslation('deal')
  const formateDate = useFormatDate()
  const [editSample, setEditSample] = useState(false)

  const sampleOpt = [
    {
      label: t('accordion.sample.sampleNumber'),
      value: (
        <ARouterLink eventName="sample_detail" to={generatePath(SamplesRoutes.Details, { id: actualSample.id })}>
          {actualSample.id}
        </ARouterLink>
      ),
    },
    {
      label: (
        <div>
          {/* <div>{t('accordion.sample.deadline')}</div>
          <div>{formateDate(actualSample.expire_at)}</div> */}
        </div>
      ),
      value: <SamplePartsForAccordion sampleShort={actualSample} />,
    },
  ]
  return (
    <>
      <SamplesCommonTable
        editBtnId="editSample"
        header={
          <AntTag color="blue">{`${t('accordion.sample.sampleResult')} ${t('common:from')} ${formateDate(
            actualSample.published_at,
          )}`}</AntTag>
        }
        options={sampleOpt}
        editModalHandler={() => setEditSample(true)}
      />

      {editSample && (
        <EditSampleModal sample={actualSample} refetch={sampleRefetch} onClose={() => setEditSample(false)} />
      )}
    </>
  )
}
